import { createSlice } from "@reduxjs/toolkit";
import { getRefundById, getRefundList } from "./ThunkAction";
import { iRefundState, REDUCER_NAME } from "./Types"; 

const extractRefundList = (payload: any) => {
  const source = payload?.data;
  if (Array.isArray(source?.refunds)) return source.refunds;
  if (Array.isArray(source?.refundList)) return source.refundList;
  if (Array.isArray(source?.data?.refunds)) return source.data.refunds;
  if (Array.isArray(source?.data?.refundList)) return source.data.refundList;
  if (Array.isArray(source?.data)) return source.data;
  return [];
};

const extractRefundDetail = (payload: any) => {
  const source = payload?.data;
  return source?.refund ?? source?.data ?? source ?? null;
};

// Define initial state based on the provided structure
const initialState: iRefundState = {
  isLoading: false,
  refundList: [], 
  errorMessage: null,
  refundDetail:null,

};
export const refundSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetRefundState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRefundList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRefundList.fulfilled, (state, action) => {
        const payload = action.payload;
        state.refundList = extractRefundList(payload);
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(getRefundList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch refund data";
        state.isLoading = false;
      })
      .addCase(getRefundById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRefundById.fulfilled, (state, action) => {
        const payload = action.payload;
        state.refundDetail = extractRefundDetail(payload);
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(getRefundById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch refund data";
        state.isLoading = false;
      });
  },
});

export const { resetRefundState } = refundSlice.actions;
export default refundSlice.reducer;
